import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback } from 'react';
import { Action, ActionSubject, EventType } from '../../../../analytics';
import { useAutocompleteLoading, useAutocompleteOptions, useStoreActions } from '../../../../state';
import AutocompleteDropdown from '../autocomplete-dropdown';

var Autocomplete = function Autocomplete(_ref) {
  var keymap = _ref.keymap,
      onClick = _ref.onClick;

  var _useAutocompleteOptio = useAutocompleteOptions(),
      _useAutocompleteOptio2 = _slicedToArray(_useAutocompleteOptio, 1),
      options = _useAutocompleteOptio2[0];

  var _useAutocompleteLoadi = useAutocompleteLoading(),
      _useAutocompleteLoadi2 = _slicedToArray(_useAutocompleteLoadi, 1),
      loading = _useAutocompleteLoadi2[0];

  var _useStoreActions = useStoreActions(),
      _useStoreActions2 = _slicedToArray(_useStoreActions, 2),
      createAndFireAnalyticsEvent = _useStoreActions2[1].createAndFireAnalyticsEvent;

  var handleClick = useCallback(function (option, analyticsAttributes) {
    onClick(option);
    createAndFireAnalyticsEvent({
      action: Action.SELECTED,
      actionSubject: ActionSubject.AUTOCOMPLETE_OPTION,
      eventType: EventType.TRACK,
      attributes: _objectSpread({}, analyticsAttributes)
    });
  }, [createAndFireAnalyticsEvent, onClick]);
  return /*#__PURE__*/React.createElement(AutocompleteDropdown, {
    options: options,
    loading: loading,
    keymap: keymap,
    onClick: handleClick
  });
};

export default Autocomplete;